import script from "./FamilyGroupInviteModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupInviteModal.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupInviteModal.vue?vue&type=style&index=0&id=45e880f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e880f4"]])

export default __exports__